import React, { useEffect, useRef } from "react";
import { gsap } from "gsap/dist/gsap";
import style from "./loader.module.scss";

const Loader = () => {
  let bg = useRef(null);
  let word = useRef(null);
  useEffect(() => {
    var tll = gsap.timeline();
    tll
      .to(word, {
        delay: 0.5,
        translateY: "0px",
        ease: "power4.out",
        duration: 1,
      })
      .to(word, {
        delay: 1,
        opacity: 0,
        ease: "power4.out",
        duration: 1,
      })
      .to(bg, {
        delay: 0.5,
        height: "0vh",
        ease: "power4",
        duration: 1,
      });
  });
  return (
    <>
      <div ref={(el) => (bg = el)} className={style.container}>
        <div>
          <h1 ref={(el) => (word = el)}>
            <span>Welcome to</span> Texhnext <span>&#xAE;</span>
          </h1>
        </div>
      </div>
    </>
  );
};

export { Loader };
